import React from 'react';
import { FaTrashAlt, FaPenSquare, FaHandHoldingUsd } from 'react-icons/fa';
import {
  EditButton,
  DeleteButton,
  ViewPaymentsButton,
} from '../styles/ComponentStyles';
import {
  BillsTableWrapper,
  BillsTableEl,
  BillsTableHeader,
  BillsTableRow,
  BillsTableData,
  TypeBadge,
  StatusBadgeBills,
} from '../styles/BillsTableStyles';
import PaginationControl from './PaginationControl';
import { balanceColor, statusColor, formatMoney } from '../utils/receivableMath';

const ReceivablesTable = ({
  receivables = [],
  loading,
  error,
  handleDelete,
  currentPage,
  currentPageLimit = 100,
  totalPages = 1,
  onPageChange,
  onPageLimitChange,
  onEdit,
  onViewDetail,
}) => {
  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error loading receivables.</div>;

  return (
    <BillsTableWrapper>
      <h2>Receivables</h2>
      <BillsTableEl>
        <thead>
          <tr>
            <BillsTableHeader>Debtor</BillsTableHeader>
            <BillsTableHeader>Frequency</BillsTableHeader>
            <BillsTableHeader>Total Owed</BillsTableHeader>
            <BillsTableHeader>Total Paid</BillsTableHeader>
            <BillsTableHeader>Balance</BillsTableHeader>
            <BillsTableHeader>Status</BillsTableHeader>
            <BillsTableHeader>Actions</BillsTableHeader>
          </tr>
        </thead>
        <tbody>
          {receivables.map((rec) => (
            <BillsTableRow key={rec._id}>
              <BillsTableData>{rec.debtor || '—'}</BillsTableData>
              <BillsTableData>
                <TypeBadge $variant="subscription">{rec.frequency || '—'}</TypeBadge>
              </BillsTableData>
              <BillsTableData>{formatMoney(rec.total_owed)}</BillsTableData>
              <BillsTableData>{formatMoney(rec.total_paid)}</BillsTableData>
              <BillsTableData>
                <StatusBadgeBills $color={balanceColor(rec.balance, rec.is_settled)}>
                  {formatMoney(rec.balance)}
                </StatusBadgeBills>
              </BillsTableData>
              <BillsTableData>
                <StatusBadgeBills $color={statusColor(rec.status)}>
                  {rec.status || 'Ongoing'}
                </StatusBadgeBills>
              </BillsTableData>
              <BillsTableData>
                {onViewDetail && (
                  <ViewPaymentsButton onClick={() => onViewDetail(rec)} title="Details">
                    <FaHandHoldingUsd />
                  </ViewPaymentsButton>
                )}
                <EditButton onClick={() => onEdit(rec)} title="Edit">
                  <FaPenSquare />
                </EditButton>
                <DeleteButton onClick={() => handleDelete(rec._id)} title="Delete">
                  <FaTrashAlt />
                </DeleteButton>
              </BillsTableData>
            </BillsTableRow>
          ))}
          {receivables.length === 0 && (
            <tr>
              <td colSpan={7} style={{ padding: 16, color: '#888' }}>
                No receivables yet. Add one to start tracking what you're owed.
              </td>
            </tr>
          )}
        </tbody>
      </BillsTableEl>

      <PaginationControl
        currentPage={currentPage}
        currentPageLimit={currentPageLimit}
        totalPages={totalPages}
        handlePageChange={onPageChange}
        handlePageLimitChange={onPageLimitChange}
      />
    </BillsTableWrapper>
  );
};

export default ReceivablesTable;
